import { Component, QueryList, ViewChildren, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';
import { firstValueFrom, Observable, Subscription } from 'rxjs';

import { Platform, IonRouterOutlet, AlertController, ModalController, ToastController } from '@ionic/angular';

// Awesome Cordova Plugins
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { PushNotifications, Token, ActionPerformed, PushNotificationSchema } from '@capacitor/push-notifications';

// Capacitor Plugins
import { App } from '@capacitor/app';

// External Libraries
import { TranslateService } from '@ngx-translate/core';
import { register } from 'swiper/element/bundle';
register();

// Custom Services / Providers
import { Events } from './provider/events.service';
import { AuthService } from './services/auth.service';
import { ConfigService } from './provider/config.service';
import { DataService } from './services/data.service';
import { RouterStateTrackerService } from './services/router-state-tracker.service';
import { ThemeService } from './services/theme.service';
import { PreferencesService } from './services/preferences.service';
// import { MasterDataService } from './services/master-data.service';
import { MenuDataService } from './services/menu-data.service';
import moment from 'moment';
type SlidePosition = '/calendar' | '/menu' | '/order' | '/notifications' | '/accounts' | any;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnDestroy {
  @ViewChildren(IonRouterOutlet) routerOutlets!: QueryList<IonRouterOutlet>;

  public connectedToInternet: boolean = true;
  public backButton = true;
  public settings: any = {};
  public currentRouteValue!: string;
  public currentActiveRoute!: string;
  public headSize: string = '';
  today: string = moment().format('YYYY-MM-DD');
  private subscription = new Subscription();
  mainProfile: Observable<any>;
  customer: any = {};
  onlineOrders: boolean = false;
  storeData: any;
  isCelebrityFeatureEnabled: boolean;
  dialCode: any;
  isDateWiseMenuEnabled: number;
  userPhoneAllowedDigit: any;
  isReferralEnabled: boolean;
  splashScreen: boolean = true;
  currentPos: string = '';
previousPos: string = '';
tabAllow:boolean=true;
  pushToken: string;
  constructor(
    private router: Router,
    private platform: Platform,
    private events: Events,
    private network: Network,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private authService: AuthService,
    private configService: ConfigService,
    private dataService: DataService,
    private routerStateTrackerService: RouterStateTrackerService,
    public themeService: ThemeService, // Made public for use in getBarClass
    private changeDetectorRef: ChangeDetectorRef,
    private preference: PreferencesService,
    private menuDataService: MenuDataService,
  ) {
    this.initializeApp();
    this.setupRouterTracking();
  }
onSlide(event: { current: SlidePosition; previous: SlidePosition }) {
  console.log('Snapped to:', event.current, 'from:', event.previous);
  // this.tabAllow = !this.routerStateTrackerService.isNavigating;
  // console.log(this.tabAllow, this.routerStateTrackerService.isNavigating, "taballow, routere");
  this.navigate(event.current)
}

  async ionViewWillEnter() {
       this.platform.ready().then(() => {
      // 2. Call the setup method
      this.setupPushNotifications();
    });
  }
  async initializeApp() {
    // await this.platform.ready();
    // this.dataService.preloadEssentialData().subscribe(
    //   () => {},
    //   (error) => {
    //     console.error('Error preloading essential data:', error);
    //   },
    // );
    this.splashScreen = true;

    try {
      const result = await firstValueFrom(this.dataService.preloadEssentialData());
      // console.log('User data loaded:', result);
      this.splashScreen = false;
      await this.themeService.getData();
      this.preference.fetchPreferences();
      this.subscription.add(
        this.authService.currentUser$.pipe(distinctUntilChanged()).subscribe(async (user: any | null) => {
          if (user?.id && this.authService.getAuthVerify() === 'true') {
            this.customer = user;
            this.menuDataService.fetchAndCacheSubscriptions();
          }
        }),
      );

      this.subscription.add(
        this.configService.appSettings$.subscribe((settings) => {
          this.settings = settings;
          if (this.settings.appLanguage) {
            document.documentElement.lang = this.settings.appLanguage;
            document.documentElement.dir = this.settings.appDirection;
            this.translate.setDefaultLang(this.settings.appLanguage);
            this.translate.use(this.settings.appLanguage);
          }
          this.changeDetectorRef.detectChanges();
        }),
      );

      this.subscription.add(
        this.themeService.currentheaderSize.subscribe((value) => {
           setTimeout(() => (this.headSize = value));
        }),
      );

      this.subscription.add(this.events.subscribe('language:change', (data: any) => {}));

      this.subscription.add(this.events.subscribe('DarkMode:change', (data: any) => {}));

      this.subscription.add(this.events.subscribe('setTheme:change', (data: any) => {}));

      this.subscription.add(this.events.subscribe('user:login', (data: any) => this.handleAuthEvent(data)));

      if (this.platform.is('capacitor')) {
        this.subscription.add(
          this.network.onDisconnect().subscribe(async () => {
            this.connectedToInternet = false;
            const alert = await this.alertCtrl.create({
              header: this.translate.instant('no_internet'),
              message: this.translate.instant('please_connect_to_the_internet'),
              mode: 'ios',
              buttons: [
                {
                  text: this.translate.instant('ok'),
                  handler: () => App.exitApp(),
                },
              ],
            });
            await alert.present();
          }),
        );

        this.subscription.add(
          this.network.onConnect().subscribe(async () => {
            if (!this.connectedToInternet) {
              const toast = await this.toastCtrl.create({
                message: this.translate.instant('network_connected_reloading_data'),
                duration: 2000,
                position: 'top',
                color: 'primary',
              });
              await toast.present();
            }
            this.connectedToInternet = true;
          }),
        );
      }
    } catch (error) {
      this.splashScreen = false;
    } finally {
      const config = await this.configService.configurationsSync();
      // console.log(config, 'config');
      this.storeData = config;
      this.isReferralEnabled = this.storeData?.is_referral_enabled === 1;
      this.userPhoneAllowedDigit = this.storeData.allowed_digit_for_phone || 10;
      this.isDateWiseMenuEnabled = Number(this.storeData.is_menu_date_wise) || 0;
      console.log(this.isDateWiseMenuEnabled, 'datewise');
      // if (this.isDateWiseMenuEnabled === 1) {
      //   // this.dataService.getData('menus', { date: this.today }).subscribe();
      // } else {
      //   // this.dataService.getData('menus').subscribe();
      // }
      this.dialCode = this.storeData.dialing_code;
      this.isCelebrityFeatureEnabled = this.storeData?.is_celebrity_feature_enabled === 1;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setupRouterTracking() {
    const routerEvents$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
    );

    this.subscription.add(
      routerEvents$.subscribe((url) => {
        this.currentActiveRoute = url;
        this.currentRouteValue = url;
      }),
    );

    this.currentRouteValue = this.router.url;
  }
  setupPushNotifications(): void {
    PushNotifications.requestPermissions().then((result) => {
      if (result.receive === 'granted') {
        PushNotifications.register();
        // this.getFCMToken();
      } else {
        PushNotifications.register();
      }
    });
        PushNotifications.register();
    PushNotifications.addListener('registration', (token: Token) => {
      this.pushToken = token.value;
      console.log("token", this.pushToken)
    });

    PushNotifications.addListener('registrationError', (error: any) => {
      console.error('Push registration error:', error);
    });

    PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {});

    PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {});
  }
  getBarClass(element: string) {
    this.onlineOrders = true;
    // console.log(this.onlineOrders);
    const tabRoutes = ['/calendar', '/menu', this.onlineOrders ? '/order' : '/notifications', '/accounts'];
    const isTabRoute = tabRoutes.includes(this.currentActiveRoute);
    const useSmallOrHideClasses = !isTabRoute || this.themeService.macros.calories === 0;

    if (!isTabRoute) {
      return 'hiddenBlur';
    }

    if (element === 'tab') {
      return useSmallOrHideClasses ? 'smallTab' : 'fullTab';
    } else if (element === 'macros') {
      return useSmallOrHideClasses ? 'hideMacros' : 'showMacros';
    } else if (element === 'blur') {
      return useSmallOrHideClasses ? 'smallBlurrer2' : 'bigBlurrer2';
    }
    return '';
  }

  async handleAuthEvent(data: { user: any | null }) {
    if (!data.user) {
      await this.configService.updateAppSettings({ currentUser: null });
      try {
        const modal = await this.modalCtrl.getTop();
        if (modal) {
          await modal.dismiss();
        }
      } catch (error) {
        console.error('Error dismissing modal on logout:', error);
      }
      this.authService.logOutUser();
      this.routerStateTrackerService.navigateWithPreExitAnimation('/onboarding', { state: 'unAuthenticated', item: '' });
    }
  }

  navigate = (data: string) => {
    this.routerStateTrackerService.navigateWithPreExitAnimation(data);
  };
}
